<script setup lang="ts">
import RichTextEditor from '../core/RichTextEditor.vue';
import { AiPlugin, pluginName, aiMenuButton, aiContextToolbar } from './tinymce/plugins/aiplugin/plugin';

const model = defineModel<string>({ default: '' });
const props = withDefaults(defineProps<{
    id: string;
    name?: string;
    disabled?: boolean;
    setup?: (editor: any) => void;
    options?: (options: any) => any;
    templates?: (templates: any[]) => any[];
}>(), {
    name: undefined,
    disabled: false,
    setup: (editor: any) => {},
    options: (options: any) => options,
    templates: (templates: any[]) => templates
});

const emit = defineEmits<{
    (e: 'input', value: string): void;
}>();

const aiStore = useAiSettingsStore();

function settingsFn(options: any)
{
    return props.options({
        ...options,
        plugins: [pluginName, ...options.plugins],
        toolbar: `${aiMenuButton} | ${options.toolbar}`,
        contextmenu: `${aiContextToolbar} | ${options.contextmenu}`
    });
}

function setupFn(editor: any)
{
    AiPlugin(editor.editorManager, { enabled: aiStore.aiEnabled });

    props.setup(editor);
}
</script>

<template>
    <RichTextEditor
        :id="props.id"
        v-model="model"
        :name="props.name"
        :setup="setupFn"
        :options="settingsFn"
        :templates="props.templates"
        @input="emit('input', $event)"
    />
</template>
